<script setup>
  import ComponentUnsavedChanges from "@components/Alerts/UnsavedChanges.vue";
  import ComponentCard from "@components/Cards/Card.vue";
  import ComponentEditor from "@components/Editor/Editor.vue";
  import {useForm} from "@inertiajs/vue3";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientsPatientNoteData",
  });

  const props = defineProps({
    patient: {
      type: Object,
      required: true,
    },
  });

  const form = useForm({
    note: props?.patient?.note,
  });

  function save() {
    form.patch(route("patients.update", {patient: props.patient.id}), {preserveScroll: true});
  }
</script>

<template>
  <form :data-test="getTestId('patient-note-data-form')" @submit.prevent="save">
    <ComponentCard
      title="Patientennotiz"
      subtitle="Sie haben überall im MediCheck Zugriff auf diese Notizen zu Ihrem Patienten."
      class="rounded-lg border-2 border-gray-200"
      :test-id="getTestId('patient-note-data-form')"
    >
      <ComponentEditor
        v-model="form.note"
        editor-class="h-52 max-h-[75vh]"
        label="Patientennotiz"
        :encrypted="true"
        :test-id="getTestId('patient-note-data-form-card-note')"
      />

      <template #actions>
        <MedButton
          variant="primary"
          :disabled="form.processing"
          :data-test="getTestId('patient-note-data-form-card-save-button')"
          @click="save()"
        >
          Speichern
        </MedButton>

        <ComponentUnsavedChanges :form="form" />
      </template>
    </ComponentCard>
  </form>
</template>
